module.exports = (__webpack_require__(4))(1727);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/history/DOMUtils.js from dll-reference vendorProd_library
// module id = 1397
// module chunks = 42